import type { Client } from '@bugsnag/browser';
import { InjectionToken } from '@angular/core';

export const BugsnagClient = new InjectionToken<Client>('BugsnagClient');

export const BUGSNAG_API_KEY = new InjectionToken<string>('BugsnagApiKey');
